import { render, staticRenderFns } from "./PcaPlotsRegions.vue?vue&type=template&id=a62afa32&scoped=true"
import script from "./PcaPlotsRegions.vue?vue&type=script&lang=js"
export * from "./PcaPlotsRegions.vue?vue&type=script&lang=js"
import style0 from "./PcaPlotsRegions.vue?vue&type=style&index=0&id=a62afa32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a62afa32",
  null
  
)

export default component.exports